import { render } from "./ConsolList.vue?vue&type=template&id=5dec4024&scoped=true"
import script from "./ConsolList.vue?vue&type=script&lang=js"
export * from "./ConsolList.vue?vue&type=script&lang=js"

import "./ConsolList.vue?vue&type=style&index=0&id=5dec4024&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dec4024"]])

export default __exports__